module.exports = __webpack_public_path__ + "img/van.79b49b22.png";